const countyConfigMultiTenantSettingsReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDNOTIFICATION_COUNTY_CONFIG_MULTI_TENANT_SETTINGS':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigMultiTenantSettingsReducer;